import React, { useState, useContext } from "react";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../utils/toast";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ButtonUI from "../material-ui/ButtonUI";
import { AuthContext } from "../../context/Auth/AuthContext";
import deleteContractTemplates from "../../api/deleteContractTemplates";

const BulkDeletePopup = ({
  RequestSettingbulkid = [],
  bulkDeleteRequestSetting,
  setBulkDeleteRequestSetting,
  setRowSelection
}) => {
  const { token } = useContext(AuthContext);

  const handleClose = () => {
    setBulkDeleteRequestSetting(false);
  };

  const onBulkDelete = async (RequestSettingbulkid) => {
    const deleteAllRequestSettingFormResponse = await deleteContractTemplates({
      token: token,
      id: RequestSettingbulkid,
    });

    if (deleteAllRequestSettingFormResponse.code === 200) {
      setRowSelection({});
      setBulkDeleteRequestSetting(false);
      showSuccess("Contract Template/s deleted successfully");
    } else {
      showError("Error while bulk deleting Contract Template/s");
    }
  };

  return (
    <div className="dialog-modal">
      <Dialog
        open={bulkDeleteRequestSetting}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="edit-doc-modal">
          <div className="popup-header-svg-icon">
            <MdDelete />
          </div>
          <div className="popup-header-title">Delete Contract Template</div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete these Contract Template/s ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="No"
            style={{ marginTop: "15px" }}
            onClickFunc={handleClose}
          />
          <ButtonUI
            formButton={false}
            variant="outlined"
            buttonText="Yes"
            style={{ marginTop: "15px" }}
            autoFocus={true}
            onClickFunc={() => {
              onBulkDelete(RequestSettingbulkid);
            }}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BulkDeletePopup;
